import { getGlobalHitPath, type FacilityHit, type PersonHit } from "@/components/AlgoliaSearch";
import { otherFacilityCountFromEmployments } from "@/lib/personSecondaryLine";
import type { GlobalSearchFacilityNode, GlobalSearchPersonNode } from "./queries";

export function toGlobalSearchPersonHit(node: GlobalSearchPersonNode): PersonHit {
  const pgaId = node.pgaId ?? "";
  return {
    objectID: node.id,
    object_type: "Person",
    pga_id: pgaId,
    name: node.displayName,
    preferred_name: node.displayName,
    profile_photo: node.profilePhoto ?? undefined,
    section_id: node.primarySection?.id ?? undefined,
    section_name: node.primarySection?.name ?? undefined,
    facility_name: node.primaryFacility?.name ?? undefined,
    other_facility_count: otherFacilityCountFromEmployments(node.primaryFacility?.id, node.employments),
    state: node.primaryFacility?.addresses?.find((address) => address.state)?.state ?? undefined,
    legacy_id: pgaId
  };
}

export function toGlobalSearchFacilityHit(node: GlobalSearchFacilityNode): FacilityHit {
  return {
    objectID: node.id,
    object_type: "Facility",
    facility_id: node.id,
    name: node.name,
    facility_name: node.name,
    city: node.mainAddress?.city ?? "",
    state: node.mainAddress?.state ?? "",
    section_id: node.section?.id ?? "",
    section_name: node.section?.name ?? "",
    legacy_id: node.legacyId ?? undefined
  };
}

export function navigableGlobalSearchHits<T extends PersonHit | FacilityHit>(hits: T[]): T[] {
  return hits.filter((hit) => getGlobalHitPath(hit));
}
